import React from 'react';
import TabsPanel from './TabsPanel';
import Enroll from '../../directmodel/components/Enroll';
const EnrollWrapper = () => {
    const pageDetails = JSON.parse(document.getElementById('data-page-details') && document.getElementById('data-page-details').innerHTML || '{}');
    return (<>
        {pageDetails.panel === 'ppgf' ? <TabsPanel /> : <Enroll />}
    </>)
};
export default EnrollWrapper;